// Auth = the API key. Magic-link login: read #k=<key> from the URL fragment,
// persist to localStorage, then scrub the fragment so the key never lingers in
// the address bar (and was never sent to a server: fragments aren't transmitted).

const KEY_STORAGE = "demoKey";

/** Extract the key from a location hash like "#k=abc" or "#foo&k=abc". */
export function readKeyFromHash(hash: string): string | null {
  const m = hash.match(/[#&]k=([^&]+)/);
  return m ? decodeURIComponent(m[1]) : null;
}

export function loadKey(store: Storage): string | null {
  return store.getItem(KEY_STORAGE);
}

export function saveKey(store: Storage, key: string): void {
  store.setItem(KEY_STORAGE, key);
}

export function clearKey(store: Storage): void {
  store.removeItem(KEY_STORAGE);
}

/**
 * If the URL fragment carries a key, persist it and scrub the fragment via
 * history.replaceState. Returns the key found in the hash (or null). The
 * caller still reads the effective key via loadKey() afterwards.
 */
export function consumeHashKey(loc: Location, hist: History, store: Storage): string | null {
  const key = readKeyFromHash(loc.hash);
  if (key) {
    saveKey(store, key);
    hist.replaceState(null, "", loc.pathname + loc.search);
  }
  return key;
}
